import { InteractionStepType, InteractionStepConfig } from '@scale/shared/types/chat';

import { StepDescriptor } from '../stepDescriptor/StepDescriptor';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';
import { schema } from './validation';
import ModelResponseRankingConfigurationComponent from './Components/ModelResponseRankingConfigurationComponent';
import ModelResponseRankingViewComponent from './Components/ModelResponseRankingViewComponent';
import ModelResponseRankingPinnedViewComponent from './Components/ModelResponseRankingPinnedViewComponent';

class ModelResponseRankingDescriptor extends StepDescriptor<InteractionStepType.ModelResponseRanking> {
  type = InteractionStepType.ModelResponseRanking;

  title = InteractionStepConfig[InteractionStepType.ModelResponseRanking].title;
  description = InteractionStepConfig[InteractionStepType.ModelResponseRanking].description;

  validationSchema = schema;

  ViewComponent = ModelResponseRankingViewComponent;
  PinnedViewComponent = ModelResponseRankingPinnedViewComponent;
  ConfigurationComponent = ModelResponseRankingConfigurationComponent;

  getResponseTemplatePaths() {
    return [
      { path: 'context.rankedCandidates', label: 'Ranked Candidates', isResponseRanking: true },
    ];
  }

  generateEmptyResponse() {
    return {
      type: InteractionStepType.ModelResponseRanking,
      context: {
        rankedCandidates: [],
      },
      output: '',
    };
  }
}

registerStepDescriptor({
  type: InteractionStepType.ModelResponseRanking,
  descriptor: new ModelResponseRankingDescriptor(),
});
